import moment from 'moment-timezone';

export default function useActionTier (startTime, paid, editBookingStationTime, tierPriceToLocationPrice) {
  function tierAction (tier, bookingStationTimeId) {
    editBookingStationTime(bookingStationTimeId, 'tier', tier);
    editBookingStationTime(
      bookingStationTimeId,
      'endTime',
      moment(startTime.value).add(tier.length, 'minutes').format(),
    );

    if (paid.value) {
      editBookingStationTime(bookingStationTimeId, 'amountPaid', tierPriceToLocationPrice(tier.price));
      editBookingStationTime(bookingStationTimeId, 'amountDue', 0);
    } else {
      editBookingStationTime(bookingStationTimeId, 'amountDue', tierPriceToLocationPrice(tier.price));
      editBookingStationTime(bookingStationTimeId, 'amountPaid', 0);
    }
  }

  return {
    tierAction,
  };
}
